export const backend_host =
  process.env.REACT_APP_BACKEND_HOST || "";
export const user_backend_host =
  process.env.REACT_APP_USER_BACKEND_HOST || "";
